// extracted by mini-css-extract-plugin
module.exports = {"country-row":"VwtEVyob6D7FyMy4vhYuw","country-name":"NnMlheTQLxC7YD6COkxr"};